import React from 'react';
import PropTypes from 'prop-types';
import { TextInput, View } from 'react-native';
import Icon from 'LocalGluons/components/Icon';

import defaultStyles, { placeholderTextColor } from './CancelableTextInput.jss';

const CancelableTextInput = ({
    style,
    placeholder,
    onChangeText,
    onCancel,
    displayCancelIcon,
    containerStyle,
    value,
    autoCapitalize,
    autoCorrect,
    secureTextEntry,
    testID
}) => {
    let textInputRef = null;

    const onCancelPress = () => {
        onCancel(textInputRef);
    };

    return (
        <View style={[defaultStyles.container, containerStyle]}>
            <TextInput
                ref={(ref) => {
                    textInputRef = ref;
                }}
                style={[defaultStyles.textInput, style]}
                placeholder={placeholder}
                placeholderTextColor={placeholderTextColor}
                onChangeText={onChangeText}
                {...(value ? { value } : {})}
                {...{
                    autoCapitalize,
                    autoCorrect,
                    secureTextEntry,
                    testID
                }}
            />
            {displayCancelIcon && (
                <View style={defaultStyles.cancelIconContainer}>
                    <Icon style={defaultStyles.cancelIcon} name="cancel" onPress={onCancelPress} />
                </View>
            )}
        </View>
    );
};

CancelableTextInput.defaultProps = {
    style: {},
    containerStyle: {},
    placeholder: '',
    value: '',
    onChangeText: () => {},
    onCancel: () => {},
    displayCancelIcon: true,
    autoCapitalize: 'none',
    autoCorrect: false,
    secureTextEntry: false,
    testID: ''
};

CancelableTextInput.propTypes = {
    style: PropTypes.shape({}),
    containerStyle: PropTypes.shape({}),
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChangeText: PropTypes.func,
    onCancel: PropTypes.func,
    displayCancelIcon: PropTypes.bool,
    autoCapitalize: PropTypes.string,
    autoCorrect: PropTypes.bool,
    secureTextEntry: PropTypes.bool,
    testID: PropTypes.string
};

export default CancelableTextInput;
